import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { ShokurekishoProjectItem } from '@/composables/format-edit/useShokurekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoJobProjectListPanel',
  props: {
    projects: { default: () => [] },
    isActive: { type: Boolean },
    addLabel: null,
    deleteItemLabel: null,
    deleteJobLabel: { default: '削除' }
  },
  emits: ["add-project", "delete-job", "ok", "move-up", "move-down", "delete-item"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add-project'): void
  (e: 'delete-job'): void
  (e: 'ok'): void
  (e: 'move-up', index: number): void
  (e: 'move-down', index: number): void
  (e: 'delete-item', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { projects: ShokurekishoProjectItem[], isActive: boolean, addLabel: string, deleteItemLabel: string, deleteJobLabel: string };





const projectList = computed(() => props.projects || [])

return { __sfc: true,props, emit, projectList }
}

})